import React from 'react';

import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import {
  formatSimpleCancellationDate,
  hoursAfterAcceptanceKeys
} from '@spotahome/marketplace-common/src/utils/cancellationPolicies';

import GenericBanner from '../GenericBanner';

const HOURS_ACCEPTANCE = 'hoursAfterAcceptance';

const getHoursAfterAcceptance = deadlines =>
  Object.keys(deadlines)
    .filter(deadline => deadlines[deadline])
    .find(
      deadline =>
        deadlines[deadline].freeCancellationDeadlineType === HOURS_ACCEPTANCE
    );

const getFreeCancellationMessage = cancellationPolicies => {
  const standardPolicy = cancellationPolicies.standard;
  const hoursAfterAcceptancePolicyName =
    getHoursAfterAcceptance(cancellationPolicies);

  if (standardPolicy && standardPolicy.freeCancellationCurrently) {
    return hoursAfterAcceptancePolicyName
      ? trans(`${hoursAfterAcceptanceKeys.bookNow}`, {
          hour: cancellationPolicies[hoursAfterAcceptancePolicyName]
            .freeCancellationDeadlineValue
        })
      : trans(
          `fee-cancellation-banner.freeCancellationCurrently.text`,
          formatSimpleCancellationDate(
            standardPolicy.freeCancellationDeadlineValue
          )
        );
  }

  return trans('fee-cancellation-banner.noFreeCancellationCurrently.text');
};

const FreeCancellationBanner = ({ moveIn, cancellationPolicies }) => {
  const content = moveIn
    ? getFreeCancellationMessage(cancellationPolicies)
    : trans('fee-cancellation-banner.noMoveIn.text');

  return (
    <GenericBanner
      dataTest="free-cancellation-banner"
      label={trans('free-cancellation-banner.label')}
      content={content}
      color="blue-cerulean"
    />
  );
};

FreeCancellationBanner.propTypes = {
  moveIn: PropTypes.string,
  cancellationPolicies: PropTypes.shape({
    standard: PropTypes.shape({
      freeCancellationCurrently: PropTypes.bool,
      freeCancellationDeadline: PropTypes.string,
      deadlineType: PropTypes.string
    })
  })
};

FreeCancellationBanner.defaultProps = {
  moveIn: null,
  cancellationPolicies: {
    standard: {
      freeCancellationCurrently: false,
      deadlineType: ''
    }
  }
};

export default React.memo(FreeCancellationBanner);
